/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-12-05 11:39:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { TextStyle } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import ExcludeProductItem from 'src/components/views/recommendation/general-settings/list/exclude-product-item';
import NoProduct from 'src/components/views/recommendation/general-settings/list/no-product';

class ExcludeProductList extends Component {
  render() {
    const { i18n, products = [], onRemove, onToggleModal, limitSelection } = this.props;
    return (
      <div>
        <TextStyle variation="strong">
          {i18n.translate('AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.title')}
        </TextStyle>
        {
          limitSelection === products.length ?
            <span
              className="BC-RecomendGeneralSetting_TextButton-disable"
            >
              {i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.button_Add'
              )}
            </span> :
            <span
              className="BC-RecomendGeneralSetting_TextButton"
              onClick={onToggleModal}>
              {i18n.translate(
                'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.button_Add'
              )}
            </span>
        }
        {
          limitSelection === products.length &&
          (
            <div className="ProductsList__note-wrapper">
              <span className="ProductsList__note-content">
                {i18n.translate(
                  'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.note',
                  {
                    t1: (
                      <span className="ProductsList__note-strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.note_t1'
                        )}
                      </span>
                    ),
                    t2: (
                      <span className="ProductsList__note-highlight">
                        {i18n.translate(
                          'AdminHTML.Recommendation.GeneralSettings.ExcludeProducts.note_t2'
                        )}
                      </span>
                    ),
                  }
                )
                }
              </span>
            </div>
          )
        }
        <div className="BC-RecomendGeneralSetting_ProductList">
          {products.length > 0 ? (
            <ul className="ProductsList">
              {products.map(product => (
                <li key={product.id}>
                  <ExcludeProductItem product={product} onRemove={onRemove} />
                </li>
              ))}
            </ul>
          ) : <NoProduct />}
        </div>
      </div>
    )
  }
}
export default withI18n()(ExcludeProductList);
